import { render } from "./tracesource.vue?vue&type=template&id=dfe84636&scoped=true"
import script from "./tracesource.vue?vue&type=script&lang=js"
export * from "./tracesource.vue?vue&type=script&lang=js"

import "./tracesource.vue?vue&type=style&index=0&id=dfe84636&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/溯源H5正式环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe84636"]])

export default __exports__